module.exports = __webpack_public_path__ + "92a01c50e046af69add79ef756cd773d.png";